import { ProductData, Slot, SlotType } from '../services';
import type { IProduct } from '../types';
import { productDataTransformer } from './dataTransformer';

enum DerivedAvailabilityStatusInternal {
  InStock = 'IN_STOCK',
  OutOfStock = 'OUT_OF_STOCK',
  LowStock = 'LOW_STOCK',
  Nya = 'NYA',
  Bo = 'BO',
  Nla = 'NLA',
  Naw = 'NAW',
  Pbo = 'PBO', // To be added from backend,
  Cancelled = 'CANCELLED',
  ExclusiveForYou = 'EXCLUSIVE_FOR_YOU',
}

const utilForPartialBackOrder = (slots?: Slot[]) => {
  const obj = {
    productWithBoStatusCount: 0,
    mandatoryProductCount: 0,
  };
  slots?.forEach((slot: Slot) => {
    if ((slot.type as SlotType) === SlotType.Pool) {
      obj.mandatoryProductCount += slot.minQty as number;
    } else {
      obj.mandatoryProductCount += slot.products?.length as number;
    }
    slot.products?.forEach((product: ProductData) => {
      const prod = productDataTransformer(product);
      if (prod.derivedAvailabilityStatus === DerivedAvailabilityStatusInternal.Bo) {
        obj.productWithBoStatusCount += 1;
      }
    });
  });
  return obj;
};

const checkForPartialBackOrder = (productData: IProduct): DerivedAvailabilityStatusInternal => {
  if (
    productData?.isBundle &&
    productData?.bundle?.derivedAvailabilityStatus === DerivedAvailabilityStatusInternal.Bo
  ) {
    const { productWithBoStatusCount, mandatoryProductCount } = utilForPartialBackOrder(productData?.bundle?.slots);
    if (mandatoryProductCount === productWithBoStatusCount) {
      return DerivedAvailabilityStatusInternal.Bo;
    }
    return DerivedAvailabilityStatusInternal.Pbo;
  }
  return productData?.derivedAvailabilityStatus as DerivedAvailabilityStatusInternal;
};
export { checkForPartialBackOrder, DerivedAvailabilityStatusInternal };
